<div class="auth-login">
  <div class="auth-login__content">
    <div class="auth-login__flex" *ngIf="!_2faVerificationStep">
      <div class="auth-login__form">
        <img [src]="companyInfo?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" alt="logo" />
        <h1 class="auth-login__form-title mb40">
            {{ 'text_loginToH20' | dbText: { companyName: companyInfo?.branding?.company_name || companyInfo?.agency?.name } }}
        </h1>
          <div class="auth-login__group auth-login__general-error"
               *ngIf="!authKeyFromGoogle && ((serverErrors && serverErrors.message && !hasServerFieldErrors) || (!serverErrors && googleError))">
              <div class="db-server-error"
                   *ngIf="serverErrors && serverErrors.message && !hasServerFieldErrors" [innerHTML]="serverErrors.message">
              </div>
              <div class="db-server-error" *ngIf="!serverErrors && googleError" [innerHTML]="googleError"></div>
          </div>
        <div class="auth-login__changed-password" *ngIf="fromResetPassword && !serverErrors">
          <p>{{ 'text_changePasswordSuccess' | dbText }}</p>
        </div>
        <form [formGroup]="loginForm" (keydown)="keyDownFunction($event)">
          <div class="db-google-block" *ngIf="!authKeyFromGoogle && !invitationData && companyInfo?.branding?.google_client_id">
            <db-google-auth (verifyGoogleToken)="verifyToken($event)" [loading]="googleLoading"
                            [googleClientId]="companyInfo?.branding?.google_client_id"></db-google-auth>
          </div>
          <div class="db-google-divider" *ngIf="!authKeyFromGoogle && !invitationData && companyInfo?.branding?.google_client_id">
            <span>or</span>
          </div>
        <div class="auth-login__notification" *ngIf="userNotVerified || verified">
          <div class="auth-notification__icon-wrap">
            <i class="db-icon db-icon-info"></i>
          </div>
          <div class="auth-notification__text-wrap"
               [innerHTML]="(verified ? 'text_emailConfirmed' : (userNotVerified ? 'text_confirmEmailLogin' : 'text_confirmEmail') ) | dbText"></div>
        </div>


        <div>
          <div class="auth-login__group auth-login__general-error"
               *ngIf="authKeyFromGoogle && (serverErrors && serverErrors.message && !hasServerFieldErrors)">
            <div class="db-server-error">
              {{ serverErrors.message === 'The user email or password is incorrect.' ? 'The user password is incorrect.' : serverErrors.message }}
            </div>
          </div>
          <div class="auth-login__group">
            <input class="ds-input-black" *ngIf="!authKeyFromGoogle" [ngClass]="{'db-disabled': authKeyFromGoogle}"
                   maxlength="100" type="email" name="email" [placeholder]="'text_emailAddress' | dbText" required
                   [style.border-color]="(loginForm.controls['email'].invalid && ((loginForm.controls['email'].touched && !loginForm.controls['email'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.message)) ? '#E95E5B' : null"
                   formControlName="email" x-autocompletetype="email">
            <div class="ds-input-black disabled" *ngIf="authKeyFromGoogle">{{ loginForm.controls['email'].value }}
            </div>
            <div class="db-server-error-wrap"
                 *ngIf="(loginForm.controls['email'].invalid && ((loginForm.controls['email'].touched && !loginForm.controls['email'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.fields.email))">
              <div
                *ngIf="(loginForm.controls['email'].invalid && ((loginForm.controls['email'].touched && !loginForm.controls['email'].errors['required']) || formSubmitted))">
                  <i class="db-icon db-icon-ds-notice"></i>
                  {{ 'text_invalidEmail' | dbText }}
              </div>
              <div *ngIf="serverErrors && serverErrors.fields.email">{{ serverErrors.fields.email[0] }}</div>
            </div>
          </div>

          <div class="auth-login__group auth-login__group-last-child">
            <div class="auth-login__group-password">
              <input *ngIf="!showPassword" maxlength="128" class="ds-input-black ds-input-password-wrap"
                     type="password" [placeholder]="'text_createProfilePassword' | dbText" name="password" required
                     [style.border-color]="((loginForm.controls['password'].invalid && ((loginForm.controls['password'].touched && !loginForm.controls['password'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors.message) ) ? '#E95E5B' : null"
                     formControlName="password" x-autocompletetype="current-password">
              <input *ngIf="showPassword" maxlength="128" class="ds-input-black ds-input-password-wrap" type="text"
                     [placeholder]="'text_createProfilePassword' | dbText" name="password" required
                     [style.border-color]="((loginForm.controls['password'].invalid && ((loginForm.controls['password'].touched && !loginForm.controls['password'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors.message) ) ? '#E95E5B' : null"
                     formControlName="password" x-autocompletetype="current-password">
              <i class="db-icon db-icon-eye" *ngIf="!showPassword" (click)="togglePassword()"
                 title="Show password"></i>
              <i class="db-icon db-icon-eye-hide" *ngIf="showPassword" (click)="togglePassword()"
                 title="Hide password"></i>
            </div>

            <div class="db-server-error-wrap"
                 *ngIf="(loginForm.controls['password'].invalid && ((loginForm.controls['password'].touched && !loginForm.controls['password'].errors['required']) || formSubmitted) || (serverErrors && serverErrors.fields.password))">
              <div
                *ngIf="(loginForm.controls['password'].invalid && ((loginForm.controls['password'].touched && !loginForm.controls['password'].errors['required']) || formSubmitted))">
                  <i class="db-icon db-icon-ds-notice"></i>
                  {{ 'text_invalidPassword' | dbText }}
              </div>
              <div *ngIf="serverErrors && serverErrors.fields.password">{{ serverErrors.fields.password[0] }}</div>
            </div>
          </div>

          <div class="db-login-button-wrap">
            <button class="ds-btn-black ds-btn-max m" [ngClass]="{'ds-btn-disabled': loading || googleLoading}"
                    (click)="onLoginSubmit()">
              <span
                *ngIf="!loading && !isLoginFromManager">{{ (authKeyFromGoogle ? "text_confirmMakePrimary.button" : 'text_loginTitle') | dbText | lowerCaseSpecificWords }}</span>
              <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
            </button>
          </div>
        </div>
        </form>
        <div class="auth-login__footer mt16" *ngIf="!magicLinkPath">
          <div class="auth-login__footer-first" *ngIf="!authKeyFromGoogle && hasStarterTrialSubscription">
              <span>{{'text_loginDontHaveAccount' | dbText}}</span>
              <a (click)="redirectToSignUp()" class="ds-link ml5">{{'text_loginCreateAccount' | dbText}}</a>
          </div>
          <div class="auth-login__footer-another-account" *ngIf="authKeyFromGoogle" (click)="resetLoginPage()">{{'text_loginWithAnotherAccount' | dbText}}</div>
          @if (companyInfo?.agency?.can_send_email) {
            <div class="auth-login__forgot-password mt15">
              <a  class="ds-link" [routerLink]="['/forgot-password/']">{{'text_loginForgotPassword' | dbText}}?</a>
            </div>
          }
        </div>

      </div>


    </div>

    <div class="auth-login__flex" *ngIf="_2faVerificationStep" >
      <db-2fa-verification (loginWith2fa)="loginWith2fa($event)" [enabledRecaptcha]="enableRecaptcha" [isLoginFromManager]="isLoginFromManager" [_isLoginFromZendesk]="_isLoginFromZendesk" [email]="loginForm.controls['email'].value" [password]="loginForm.controls['password'].value"></db-2fa-verification>
    </div>

  </div>
  <db-loading-screen [ngClass]="{'hidden':!loadingGoogle}" [pageBlocker]="true"></db-loading-screen>
</div>
